import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'

const LogoContainer = styled('div')`
  ${flexCenter}

  width: auto;

  > img {
    display: inline-block;
    max-height: 100%;
  }

  > h4 {
    font-weight: 400;
    line-height: 2rem;
    margin: 0;
    margin-left: 5px;
    font-size: 18px;
    color: var(--CINight);

    > span {
      display: inline-block;
      font-size: 0.8rem;
      font-weight: 300;
    }
  }
`

export { LogoContainer }
